$(function() {
  $('.button-up__button').on('click', function() {
    $('body, html').animate({
      scrollTop: 0
    }, 1000);
  });

  // hide or show button
  showHideButtonUp();
  $(window).on('scroll', function() {
    showHideButtonUp();
  });

  function showHideButtonUp() {
    if($(window).scrollTop() > 1000) {
      $('.button-up').show();
    }
    else {
      $('.button-up').hide();
    }
  }
});